"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcPaymentTransactionTypeSymbol = void 0;
const UcPaymentTransactionTypeSymbol_yaml_component_1 = __importDefault(require("./UcPaymentTransactionTypeSymbol.yaml?component"));
exports.UcPaymentTransactionTypeSymbol = UcPaymentTransactionTypeSymbol_yaml_component_1.default;
